import {create} from 'zustand';

export const useLayers = create(() => ([]));